// Longest window, in days, the analytics dashboard can request.
export const ANALYTICS_MAX_RANGE_DAYS = 365;
